(() => {
  const tabsSelector = '[data-product-review-tabs]';
  const panelSelector = '[data-product-reviews-panel]';
  const radioSelector = '[data-product-reviews-radio]';
  const triggerSelector = '[data-product-reviews-trigger]';
  const reviewWidgetSelector = '#judgeme_product_reviews';

  const moveReviewWidget = (tabs) => {
    const panel = tabs.querySelector(panelSelector);
    const widget = document.querySelector(reviewWidgetSelector);

    if (!panel || !widget) return false;

    const appBlock = widget.closest('.shopify-app-block') || widget;
    const sourceSection = appBlock.closest('.shopify-section');

    if (!panel.contains(appBlock)) {
      panel.appendChild(appBlock);
    }

    if (sourceSection && !sourceSection.contains(appBlock)) {
      sourceSection.classList.add('product-reviews-source-section--empty');
    }

    panel.classList.add('product-reviews-tab-panel--ready');
    return true;
  };

  const activateReviewsTab = (tabs, smoothScroll = true) => {
    const radio = tabs.querySelector(radioSelector);
    if (!radio) return;

    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));

    window.requestAnimationFrame(() => {
      const header = document.querySelector('.site-header');
      const headerPosition = header ? window.getComputedStyle(header).position : '';
      const headerOffset = header && ['fixed', 'sticky'].includes(headerPosition)
        ? header.getBoundingClientRect().height + 24
        : 24;
      const targetPosition = window.scrollY + tabs.getBoundingClientRect().top - headerOffset;

      window.scrollTo({
        top: Math.max(0, targetPosition),
        behavior: smoothScroll ? 'smooth' : 'auto',
      });
    });
  };

  const initializeReviewTabs = () => {
    const tabs = document.querySelector(tabsSelector);
    if (!tabs || tabs.dataset.productReviewTabsInitialized === 'true') return;

    tabs.dataset.productReviewTabsInitialized = 'true';

    if (!moveReviewWidget(tabs)) {
      const observer = new MutationObserver(() => {
        if (moveReviewWidget(tabs)) observer.disconnect();
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (window.location.hash === '#judgeme_product_reviews') {
      activateReviewsTab(tabs, false);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest(triggerSelector);
      if (!trigger) return;

      const tabs = document.querySelector(tabsSelector);
      if (!tabs) return;

      event.preventDefault();
      activateReviewsTab(tabs);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeReviewTabs);
  } else {
    initializeReviewTabs();
  }

  document.addEventListener('shopify:section:load', initializeReviewTabs);
})();
